export const PointsEndpoints = {
    seedOfGood: (receiptId: number | string) =>
        `/points/online-giving/seeds-prompt/${receiptId}`,
};
